module.exports = __webpack_public_path__ + "37ba7b92/img/menu-icon.5f8facae.svg";